import { render } from "./comfirmButton.vue?vue&type=template&id=5d928778&scoped=true"
import script from "./comfirmButton.vue?vue&type=script&lang=js"
export * from "./comfirmButton.vue?vue&type=script&lang=js"

import "./comfirmButton.vue?vue&type=style&index=0&id=5d928778&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d928778"]])

export default __exports__